// extracted by mini-css-extract-plugin
var _1 = "LinkifiedTextRenderer_icon__rOQqT";
var _2 = "LinkifiedTextRenderer_wrapper__nuhP-";
export { _1 as "icon", _2 as "wrapper" }
